// extracted by mini-css-extract-plugin
export default {"dynamicBanner":"NE-z"};